<template>
  <v-text-field
    :value="value"
    @input="$emit('input', $event)"
    :label="label"
    outlined
    :required="required"
    :rules="rules"
    :type="type"
    :readonly="readonly"
  ></v-text-field>
</template>

<script>
export default {
  name: 'TextInput',
  props: {
    value: [String, Number],
    label: String,
    required: Boolean,
    rules: Array,
    type: String,
    readonly: Boolean
  }
}
</script>

<style scoped></style>
